import { render, staticRenderFns } from "./TaxSetting.vue?vue&type=template&id=107db260&"
import script from "./TaxSetting.vue?vue&type=script&lang=js&"
export * from "./TaxSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107db260')) {
      api.createRecord('107db260', component.options)
    } else {
      api.reload('107db260', component.options)
    }
    module.hot.accept("./TaxSetting.vue?vue&type=template&id=107db260&", function () {
      api.rerender('107db260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/TaxSetting.vue"
export default component.exports